const FeeTypesEnum = {
  Resource: 'Resource',
  DataQuality: 'DataQuality',
  RM: 'RM',
  DQ: 'DQ',
  KAM: 'KAM',
  BD: 'BD',
  BI: 'BI',
  IT: 'IT',
  HR: 'HR',
  Marketing: 'Marketing',
  Finance: 'Finance',
  FieldworkPartner: 'Fieldwork Partner',
};

export default FeeTypesEnum;
